import { defineMessages } from 'react-intl'

export default defineMessages({
  createButton: {
    id: 'OrganizationUserAttributes.CreateAttribute',
    defaultMessage: 'Create Attribute'
  },
  labelDisplayName: {
    id: 'OrganizationUserAttributes.AttributeList.DisplayName',
    defaultMessage: 'Display Name'
  },
  labelTargetable: {
    id: 'OrganizationUserAttributes.AttributeList.Targetable',
    defaultMessage: 'Targeted'
  },
  labelType: {
    id: 'OrganizationUserAttributes.AttributeList.Type',
    defaultMessage: 'Type'
  },
  typeBinary: {
    id: 'OrganizationUserAttributes.Type.Binary',
    defaultMessage: 'Binary'
  },
  typeBoolean: {
    id: 'OrganizationUserAttributes.Type.Boolean',
    defaultMessage: 'Boolean'
  },
  typeComplex: {
    id: 'OrganizationUserAttributes.Type.Complex',
    defaultMessage: 'Complex'
  },
  typeDateTime: {
    id: 'OrganizationUserAttributes.Type.Datetime',
    defaultMessage: 'Date/Time'
  },
  typeDecimal: {
    id: 'OrganizationUserAttributes.Type.Decimal',
    defaultMessage: 'Decimal'
  },
  typeInteger: {
    id: 'OrganizationUserAttributes.Type.Integer',
    defaultMessage: 'Number'
  },
  typeList: {
    id: 'OrganizationUserAttributes.Type.MultiValued',
    defaultMessage: 'List'
  },
  typeString: {
    id: 'OrganizationUserAttributes.Type.String',
    defaultMessage: 'Text'
  },
  yes: {
    id: 'Yes',
    defaultMessage: 'Yes'
  },
  no: {
    id: 'No',
    defaultMessage: 'No'
  }
})
